export function getAndIncrementAttemptCounter(storageKey: string): number {
	try {
		const stored = localStorage.getItem(storageKey);
		const current = stored ? parseInt(stored, 10) : 0;
		const next = current + 1;
		localStorage.setItem(storageKey, next.toString());
		return next;
	} catch {
		return 1;
	}
}


